<template>
	<div id="activity_menber">
		<van-tabs v-model="active">
			<van-tab title="活动成员">
				<van-search v-model="name" placeholder="根据成员姓名搜索" show-action shape="round" @search="onRefresh2">
					<div slot="action" @click="onRefresh2">搜索</div>
				</van-search>
				<van-pull-refresh v-model="isLoading2" @refresh="onRefresh2" style="margin-top: 10px;">
					<van-list v-model="loading2" :finished="finished2" finished-text="没有更多了" @load="onLoad2" :error.sync="error2" error-text="请求失败，点击重新加载">
						<div style="width: 100%;height: auto;" v-for="(item,index) in list2">
							<div style="display: flex;height: auto;background-color: white;border: 1px solid #e8e8e8;margin-bottom: 5px;">
								<div style="width: 80px;" @click="user(item.userId)">
									<img :src="item.photo|addPath" style="height: auto;width: 80%;margin: 10%;" />
								</div>
								<div style="flex: 2;font-size: 14px;" @click="user(item.userId)">
									<p style="margin: 8px 0px;">用户名 : {{item.userName}} </p>
									<p style="margin: 5px 0px;">联系电话 : {{item.phone}}</p>
									<p style="margin: 5px 0px;">签到次数 : <span style="color: #ff4500;">{{item.signCount}}</span></p>
								</div>
								<div style="flex: 0.4;text-align: center;background-color: orangered;" @click="sign(item.userId)" >
									<p style="color: white;">签到 记录</p>
									<!--<van-icon name="underway-o" style="margin-top: 22px;margin-right: 10px;" size="20px"/>-->
								</div>
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
			</van-tab>
			<van-tab title="未审核">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="margin-top: 10px;">
					<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载">
						<div style="width: 100%;height: auto;" v-for="(item,index) in list">
							<div style="display: flex;height: auto;background-color: white;border: 1px solid #e8e8e8;margin-bottom: 5px;">
								<div style="width: 80px;" @click="user(item.userId)">
									<img :src="item.photo|addPath" style="height: auto;width: 80%;margin: 10%;" />
								</div>
								<div style="flex: 2;font-size: 14px;">
									<div @click="user(item.userId)">
										<p style="margin: 8px 0px;">用户名 : {{item.userName}} </p>
										<p style="margin: 5px 0px;">联系电话 : {{item.phone}}</p>
									</div>
									<van-button style="margin: 5px;float: right;color: white;background-color: orangered;" @click="confirm(item.id,index)" type="default">通过</van-button>
								</div>
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import { Cell, CellGroup, Dialog, Pagination, NavBar, Popup, Search, Loading, Toast, Icon, Area, Picker, Button, Tab, Tabs, List, PullRefresh } from 'vant';
	import axios from 'axios';
	import store from '@/store/store.js';
	import global from '@/api/global';
	import { htmlspecialchars_decode, formatDate } from '@/js/common.js';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	import areaList from '@/js/area.js';
	Vue.use(VueCookies);
	export default {
		filters: {
			formatDate(time) {
				return formatDate(time, 'yyyy-MM-dd hh:mm:ss');
			},
			addPath(path) {
				return global.resoursePhoto + "/" + path;
			},
			addStatus(joinstate) {
				if(joinstate == 1) {
					return "待审核";
				} else {
					return "";
				}
			},
			Status(status) {
				if(status == 0) {
					return '普通成员';
				} else if(status == 1) {
					return '管理员';
				} else if(status == 2) {
					return '负责人';
				}
			}
		},
		components: {
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Dialog.name]: Dialog,
			[Pagination.name]: Pagination,
			[NavBar.name]: NavBar,
			[Popup.name]: Popup,
			[axios.name]: axios,
			[Search.name]: Search,
			[Loading.name]: Loading,
			[Toast.name]: Toast,
			[Icon.name]: Icon,
			[Area.name]: Area,
			[Picker.name]: Picker,
			[Button.name]: Button,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh
		},
		data() {
			return {
				name: "",
				active: 0,
				limit: 10,
				page: 1,
				list: [],
				isLoading: false,
				error: false,
				loading: false,
				finished: false,
				count: 0,

				page2: 1,
				list2: [],
				isLoading2: false,
				error2: false,
				loading2: false,
				finished2: false,
				count2: 0,
			}
		},
		created: function() {},
		methods: {
			sign(id){
				this.$router.push({
					path: '/admin_sign', //跳转的路径
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						projectId: this.$route.query.id,
						id:id
					}
				});
			},
			user(id) {
				this.$router.push({
					path: '/user_info', //跳转的路径
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						id: id
					}
				});
			},
			confirm(id, index) {
				Toast.loading({
					mask: true,
					message: '提交中...',
					duration: 0
				});
				axios({
					method: 'post',
					url: global.baseURL + 'appsite/attend/confirm',
					params: {
						"id": id
					}
				}).then((resp) => {
					Toast.clear();
					if(resp.data.status == 1) {
						Toast("已同意申请");
						this.onRefresh2();
						this.list.splice(index, 1);
					} else {
						Toast(resp.data.msg);
					}
				}).catch(resp => {
					Toast.clear();
					console.log(resp);
					Toast.fail('请求失败');
				});
			},
			onRefresh() {
				this.list = [];
				this.page = 1;
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/attend/selectList',
					params: {
						pageNum: this.page,
						projectId: this.$route.query.id,
						status: 1
					}
				}).then((resp) => {
					this.list = resp.data.data.data;
					this.count = resp.data.data.count;
					this.page++;
					this.isLoading = false;
					this.finished = false;
					this.error = false;
					this.loading = false;
					if(Math.ceil(this.count / this.limit) < this.page) {
						this.finished = true;
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			onLoad() {
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/attend/selectList',
					params: {
						pageNum: this.page,
						projectId: this.$route.query.id,
						status: 1
					}
				}).then((resp) => {
					for(var i = 0; i < resp.data.data.data.length; i++) {
						this.list.push(resp.data.data.data[i]);
					}
					this.count = resp.data.data.count;
					this.isLoading = false;
					this.loading = false;
					this.page++;
					if(Math.ceil(this.count / this.limit) < this.page) {
						this.finished = true;
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			onRefresh2() {
				this.list2 = [];
				this.page2 = 1;
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/attend/selectMenber',
					params: {
						userName: this.name,
						pageSize: this.limit,
						pageNum: this.page2,
						projectId: this.$route.query.id,
						status: 2
					}
				}).then((resp) => {
					this.list2 = resp.data.data.data;
					this.count2 = resp.data.data.count;
					this.page2++;
					this.isLoading2 = false;
					this.finished2 = false;
					this.error2 = false;
					this.loading2 = false;
					if(Math.ceil(this.count2 / this.limit) < this.page2) {
						this.finished2 = true;
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			onLoad2() {
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/attend/selectMenber',
					params: {
						userName: this.name,
						pageNum: this.page2,
						pageSize: this.limit,
						projectId: this.$route.query.id,
						status: 2
					}
				}).then((resp) => {
					for(var i = 0; i < resp.data.data.data.length; i++) {
						this.list2.push(resp.data.data.data[i]);
					}
					this.count2 = resp.data.data.count;
					this.isLoading2 = false;
					this.loading2 = false;
					this.page2++;
					if(Math.ceil(this.count2 / this.limit) < this.page2) {
						this.finished2 = true;
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			}
		}
	}
</script>

<style>
	#admin_add p {
		font-size: 12px;
		margin: 10px;
		color: gray;
	}
	
	#examine_act p {
		font-size: 12px;
		margin: 10px;
		color: gray;
	}
	
	#activity_menber .admin_p {
		white-space: normal;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		font-size: 14px;
		margin: 4px;
		margin-left: 10px;
		margin-top: 10px;
	}
	
	#activity_menber .admin_date {
		font-size: 10px;
		color: gray;
		margin-left: 10px;
		margin-bottom: 10px;
	}
	
	#admin_add .van-button {
		margin: 10px auto;
		color: white;
		width: 90%;
		margin-left: 5%;
		border-radius: 5px;
	}
	
	#activity_menber .admin_details {
		border-bottom: 1px solid #f7f5f5;
		width: 100%;
		height: auto;
		min-height: 80px;
		display: flex;
	}
	
	#activity_menber .active_button {
		background-color: orangered !important
	}
	
	#activity_menber .org_item {
		margin: 10px 5%;
	}
	
	#org_content * {
		width: auto;
		height: auto;
		max-width: 100%;
	}
	
	#activity_menber .org_span {
		margin-left: 6px;
	}
	
	#activity_menber .van-icon,
	#activity_menber .van-icon::before {
		vertical-align: middle;
	}
</style>